import ApiBudgety from '@/api/apiBudgety'

export const loginService = {
  solicitarRecuperacion,
  login,
  validateSimpleToken,
  loginByGoogle,
}

async function solicitarRecuperacion(email, tokenRC) {
  return await ApiBudgety.post('Usuario/SolicitudRecuperarContrasena?email=' + email, null, {
    headers: {
      tokenRC,
    },
  })
}

async function login(login, tokenRC) {
  return await ApiBudgety.post('Login/Authenticate', login, {
    headers: {
      tokenRC,
    },
  })
}

async function loginByGoogle(token, tokenRC) {
  return await ApiBudgety.get('Login/AuthenticateByGoogle/' + token, {
    headers: {
      tokenRC,
    },
  })
}

async function validateSimpleToken(uri, tokenRC) {
  return await ApiBudgety.post('Login/ValidateSimpleToken?uri=' + encodeURIComponent(uri), null, {
    headers: {
      tokenRC,
    },
  })
}
